import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { AfterClub2To4Home24LetContinueHJToAnnEND } from "./V4";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const AfterClub2To4Home = async (): Promise<any> => {
    doTransition(images.v4.AfterBarAnnRoom1);
    ann.talk(`I am glad we got home.`);
    ann.talk(`I've never gone out to places like that, and especially not walking the streets at these hours.`);
    if (Question.globalAnswers.v25JoeTODAgree) {
        ann.talk(`So I never see people like that.`);
        if (Question.globalAnswers.v4ToldAnnTeaseHobo) {

            ann.talk(`I can't believe you sided with that homeless guy...`);
            mc.talk(`I already told you! It was a joke.`);
            ann.talk(`Weird sense of humor...`);
        } else if (Question.globalAnswers.v4ToldAnnTeaseHobo === false) {

            ann.talk(`I can't believe he called me a slut...`);
            ann.talk(`Do I look like one?`);
            mc.talk(`Of course not.`);
        }
        mc.talk(`Forget about him.`);
        ann.talk(`Already forgotten!`);
    } else {
        ann.talk(`But luckily I have you by my side to protect me if anything happens!`);
        mc.talk(`Of course! I won't let anything happen to you.`);
        ann.talk(`Hehe.`);
    }
    if (mc.properties.annLateGF) {
        ann.talk(`${mc.name}...`);
        mc.talk(`Yes?`);
        ann.talk(`I just want to say that I've never spent a night at a guy's place.`);
        ann.talk(`I mean, I know I fell asleep here yesterday, but it was different.`);
        ann.talk(`I didn't think anything will happen...`);
        ann.talk(`And...`);
        mc.talk(`Ann, just relax.`);
        ann.talk(`Yes, you are right.`);
        await ann.setQuestion(new Question({ text: `So... What do you want to do?`, options: { think: false }, key: `v4ToldAnnLateGFToRemoveClothes` })
            .option({ title: `Take off your clothes`, key: true })
            .option({ title: `Whatever you feel like`, key: false }));


        if (Question.globalAnswers.v4ToldAnnLateGFToRemoveClothes) {
            await mc.set((properties) => {
                properties.alpha++;
            });
            mc.talk(`Take off your clothes.`);
            ann.talk(`Oh, wow straight forward.`);
            if (mc.properties.annLateGF) {

                ann.talk(`Just don't laugh at me!`);
                mc.talk(`I won't.`);
            } else {

            }
            ImageClass.setImage(images.v4.AfterBarAnnRoom2);
        } else {
            mc.talk(`Whatever you feel like doing.`);
            ann.talk(`Oh...`);
            ann.talk(`I am going to take off my dress.`);
            ann.talk(`Is that ok?`);
            mc.talk(`Of course.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom2);
        }

    } else if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v4.AfterBarAnnRoom1_2);
        ann.talk(`So... Here we are again!`);
        ann.talk(`In the past two days, I've been here more than in my own house.`);
        mc.talk(`Is that a bad thing?`);
        ann.talk(`Not at all, hehe.`);
        if (mc.properties.alpha > 4) {
            mc.talk(`Why are you still dressed?`);
            ann.talk(`You don't want to talk for a bit first?`);
            mc.talk(`We've talked all night and I'm horny.`);
            ann.talk(`Oh...`);
            ann.talk(`Ok...`);
        } else {
            ann.talk(`So... What do you want to do?`);
            mc.talk(`You can remove your dress if you want to.`);
            ann.talk(`I do...`);
            mc.talk(`Go ahead.`);
        }
    }

    ImageClass.setImage(images.v4.AfterBarAnnRoom2, { duration: 0.8 });
    ann.talk(`Don't get mad but I am not ready to get completely naked...`);

    mc.talk(`Come closer.`);
    mc.think(`I took off my clothes. Ann stepped closer to me and got down on her knees.`);

    if (mc.properties.annLateGF) {
        ImageClass.setImage(images.v4.AfterBarAnnRoom4);

        ann.talk(`It's my first time I'll try my best...`);
        if (mc.properties.alpha >= 5) {
            mc.talk(`It's not rocket science.`);
            ann.talk(`Sorry, I am just nervous.`);
        } else {

            mc.talk(`It's ok.`);
        }
        mc.talk(`Just grab it.`);
        ImageClass.setImage(images.v4.Anim_AfterBarAnnRoom.poster);
        ann.talk(`Ok...`);
        mc.talk(`Now stroke it.`);
        ImageClass.setAnimation(images.v4.Anim_AfterBarAnnRoom);
        mc.think(`It felt nice.`);
        mc.think(`But not nice enough for me to cum.`);
        mc.think(`I could clearly tell she lacked experience...`);

        ImageClass.setImage(images.v4.AfterBarAnnRoom5);
        await ann.setQuestion(new Question({ text: `I hope it feels good...`, options: { think: false }, key: `v4GuidedLateGFAnnOnHJ` })
            .option({ title: `Guide her`, key: true })
            .option({ title: `Let her do it`, key: false }));


        if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ) {
            ImageClass.setImage(images.v4.AfterBarAnnRoom6_2);
            mc.talk(`You should grab it like so.`);
            mc.talk(`Now, hold it firm, but not too strong.`);
            ann.talk(`Oh ok.`);
            ImageClass.setImage(images.v4.Anim_AfterBarAnnRoomAbove.poster);
            mc.talk(`Then stroke it.`);
            ImageClass.setAnimation(images.v4.Anim_AfterBarAnnRoomAbove);
            ann.talk(`Like this?`);
            mc.talk(`Yes, exactly.`);
        } else {
            ImageClass.setAnimation(images.v4.Anim_AfterBarAnnRoom);
            mc.talk(`Yes, it does.`);
            mc.think(`I don't want her to lose confidence.`);
            ann.talk(`I'm a natural! Hehe.`);
        }
        mc.talk(`We should try something different.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom4);
        ann.talk(`What do you want to try?`);
        mc.talk(`Come closer with your mouth.`);
        ann.talk(`You want me to suck it???`);
        mc.talk(`What's wrong with that?`);
        ann.talk(`I don't know... It's not something that I didn't think of trying...`);
        mc.talk(`It's your perfect opportunity.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom14);

        ann.talk(`I guess I can try...`);

        ImageClass.setImage(images.v4.AfterBarAnnRoom12);
        mc.think(`Ann started sucking my dick.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom10);
        mc.think(`She sucked the tip of my cock. It was nice but I still felt her teeth sometimes.`);
    } else {
        ImageClass.setImage(images.v4.AfterBarAnnRoom3);
        ann.talk(`Are you ready?`);
        mc.talk(`Always.`);
        if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ || Question.globalAnswers.v3HJGuidedAnn) {

            ImageClass.setImage(images.v4.AfterBarAnnRoom4);
            ann.talk(`I hope this time I'll do it just like you taught me.`);
            ImageClass.setImage(images.v4.Anim_AfterBarAnnRoom.poster);
            mc.talk(`Go ahead.`);
            ImageClass.setAnimation(images.v4.Anim_AfterBarAnnRoom);
            mc.think(`She improved, it feels really good.`);
            ann.talk(`Is that good?`);
            mc.talk(`Yes.`);
        } else {
            mc.think(`That was the second time she was stroking my dick that day.`);
            mc.think(`But again, even though she was trying her best, but it still did feel that good.`);
            mc.think(`I'd chosen not to guide her so she was doing what she thought would make me feel good...`);
        }
        if (mc.properties.alpha > 5 && Game.seenScenarios.includes("AnnAfterTODLoveBJ")) {
            mc.talk(`Where is my blowjob?`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom5);
            ann.talk(`I said maybe...`);
            mc.talk(`Don't let me down Ann.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`I'll try but I'll stop if I don't like it.`);
        } else {
            ImageClass.setImage(images.v4.AfterBarAnnRoom5);
            ann.talk(`I want to try and do something.`);
            mc.talk(`Ok.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`But I'll stop if I don't like it.`);
            mc.talk(`Go ahead.`);
        }

        ImageClass.setImage(images.v4.AfterBarAnnRoom12);
        mc.think(`She sucked the tip of my cock. It was nice but I still felt her teeth sometimes.`);
        return jump(AfterClub2To4Home24, "AfterClub2To4Home24");

    }

    return jump(AfterClub2To4Home24, "AfterClub2To4Home24");
};

export const AfterClub2To4Home24 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom12);
    await mc.setQuestion(new Question({ text: `It feels like she is not fully into it, like she really thinks on what she is doing.`, options: { think: true }, key: `v4GuidedAnnGFBJ` })
        .option({ title: `Fake moan`, key: false })
        .option({ title: `Teach her`, key: true }));


    if (Question.globalAnswers.v4GuidedAnnGFBJ) {
        if (mc.properties.alpha > 5) {
            mc.talk(`Ann, what are you doing? It's not a toothbrush.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`What?`);
            mc.talk(`Your teeth are hurting me.`);
            ann.talk(`Oh my God, I'm sorry.`);
            mc.talk(`Just open your mouth wider.`);
        } else {
            mc.talk(`Ann, open your mouth.`);
            mc.talk(`Wider so I won't feel your teeth.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`Oh, I thought you weren't feeling them.`);
        }

        ImageClass.setImage(images.v4.AfterBarAnnRoom12);
        ann.talk(`MMM???`);
        mc.talk(`Better, yes.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom10);
        mc.talk(`Now, with your tongue, put pressure on the area just under my tip and go back and forth.`);

        mc.talk(`Now, try to go as deep as you can.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom8, { duration: 0.6 });
        mc.talk(`Yeah... Ah... Deeper!`);
        ImageClass.setAnimation(images.v4.annanim);
        mc.think(`Ann acknowledges that she heard me but she can't go any deeper.`);
    } else {
        await mc.set((properties) => {
            properties.alpha--;
        });
        ImageClass.setImage(images.v4.AfterBarAnnRoom10);
        mc.talk(`Ahh... Keep going.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom12);

        ann.talk(`Mmm...`);
        ImageClass.setAnimation(images.v4.annanim);
        mc.think(`Ann acknowledged that she heard me but she was still sucking in the same way.`);

    }

    return jump(AfterClub2To4Home24_Question, "AfterClub2To4Home24_Question");
};

export const AfterClub2To4Home24_Question = async (): Promise<any> => {
    ImageClass.setAnimation(images.v4.annanim);
    await mc.setQuestion(new Question({ text: `There is a way for me to show her what I really want.`, options: { think: true }, key: `v4PushedAnnGFHeadDuringBJ` })
        .option({ title: `Aggressively push her head deeper`, key: true })
        .option({ title: `Let her continue`, key: false }));


    if (Question.globalAnswers.v4PushedAnnGFHeadDuringBJ) {
        await mc.set((properties) => {
            properties.alpha += 2;
        });
        await ann.set((properties) => {
            properties.corruption += 2;
        });
        return jump(AfterClub2To4Home24PushHead, "AfterClub2To4Home24PushHead");
    }
    return jump(AfterClub2To4Home24LetContinue, "AfterClub2To4Home24LetContinue");
};

export const AfterClub2To4Home24PushHead = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom15);
    mc.talk(`Deeper!`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom16);
    ann.talk(`MMPH!!!`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom14);
    ann.talk(`Are you trying to kill me?`);
    mc.talk(`I'm just teaching you how to do it right.`);
    if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
        ann.talk(`I should have known you'd do that again.`);
        mc.talk(`I couldn't help myself.`);
    } else {

        ann.talk(`I tried but I can't go that deep.`);
    }
    mc.talk(`Keep going I won't do that again.`);
    ann.talk(`Promise?`);
    mc.talk(`Yes.`);

    return jump(AfterClub2To4Home24LetContinue, "AfterClub2To4Home24LetContinue");
};


export const AfterClub2To4Home24LetContinue = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom8);
    mc.think(`Ann kept sucking my dick.`);
    mc.think(`Sometimes she got a little deeper than usual, but still not deep enough.`);
    if (Question.globalAnswers.v4GuidedAnnGFBJ) {

        if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ) {
            mc.think(`But she did what I taught her.`);
            mc.think(`I would have cum if I hadn't just came while watching Vanessa sucking off that dude in the alley...`);
        } else {
            return jump(AfterClub2To4Home24LetContinueQuestion, "AfterClub2To4Home24LetContinueQuestion");
        }
    }
    return jump(AfterClub2To4Home24LetContinue2, "AfterClub2To4Home24LetContinue2");
};
export const AfterClub2To4Home24LetContinueQuestion = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom8);
    await mc.setQuestion(new Question({ text: `But she is doing what I've taught her and I'm about to cum.`, options: { think: true }, key: `v4WarnedAnnGFOnCum` })
        .option({ title: `Warn her`, key: true })
        .option({ title: `Don't warn her`, key: false }));


    if (Question.globalAnswers.v4WarnedAnnGFOnCum) {

        await mc.set((properties) => {
            properties.alpha--;
        });
        mc.talk(`I'm cumming!`);
        ann.talk(`Mmmm?`);
        mc.talk(`AHHH!`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom17);
        ann.talk(`Oh!`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom3);
        ann.talk(`Good thing that you warned me!`);
    } else {

        await mc.set((properties) => {
            properties.alpha++;
        });
        await ann.set((properties) => {
            properties.corruption++;
        });
        mc.think(`Fuck!`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom18);
        mc.think(`Ahhh!!`);
        ann.talk(`MMM!!!`);
        ann.talk(`${mc.name}!`);

        if (Question.globalAnswers.v3ToldAnnLickCum) {

            ann.talk(`Napkin!`);
            mc.talk(`You've already tasted it. Try to swallow it.`);
            ann.talk(`Huh?`);
            mc.talk(`Do it. It's not a big deal.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom20);
            mc.talk(`Show me your mouth.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom21);
            ann.talk(`Ahhh.`);
            mc.talk(`That's a good girl.`);

        } else {

            return jump(AfterClub2To4Home24LetContinue_Question2, "AfterClub2To4Home24LetContinue_Question2");
        }


        return jump(AfterClub2To4Home24_Question_Continue, "AfterClub2To4Home24_Question_Continue");



    }
    return jump(AfterClub2To4Home24LetContinueHJToAnn, "AfterClub2To4Home24LetContinueHJToAnn");
};

export const AfterClub2To4Home24LetContinue_Question2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom18);
    await ann.setQuestion(new Question({ text: `Napkin!`, options: { think: false }, key: `v4ToldAnnToSwallowAfterCum` })
        .option({ title: `Give her`, key: false })
        .option({ title: `Tell her to swallow`, key: true }));


    if (Question.globalAnswers.v4ToldAnnToSwallowAfterCum) {

        await ann.set((properties) => {
            properties.corruption++;
        });
        mc.talk(`Swallow it.`);
        ann.talk(`MMM??`);
        mc.talk(`Try.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom20);
        mc.talk(`Show me your mouth.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom21);
        ann.talk(`Ahhh.`);
        mc.talk(`That's a good girl.`);

    } else {
        ImageClass.setImage(images.v4.AfterBarAnnRoom19);
        mc.talk(`Here.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom14);
        ann.talk(`Why didn't you warn me?`);
        if (mc.properties.liar >= 3) {

            mc.talk(`It felt so good I wasn't ready myself.`);
            ann.talk(`Oh...`);
            ann.talk(`At least it felt good, hehe.`);
        } else {
            mc.talk(`I didn't think it would bother you.`);
            ann.talk(`Oh...`);
        }
    }

    return jump(AfterClub2To4Home24_Question_Continue, "AfterClub2To4Home24_Question_Continue");
};

export const AfterClub2To4Home24_Question_Continue = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom13);
    ann.talk(`I wonder if all the girls do that...`);
    mc.talk(`Sucking dicks?`);
    ann.talk(`That too...`);
    mc.talk(`Just say it.`);
    ann.talk(`Taking the sperm in their mouth...`);
    ann.talk(`I know that Vanessa does that, but she is not a good example.`);
    mc.talk(`Many do.`);
    mc.talk(`It's a real turn on for me.`);
    ann.talk(`Oh. Ok.`);
    return jump(AfterClub2To4Home24LetContinueHJToAnn, "AfterClub2To4Home24LetContinueHJToAnn");
};

export const AfterClub2To4Home24LetContinue2 = async (): Promise<any> => {
    if (!Question.globalAnswers.v4GuidedAnnGFBJ) {

        mc.think(`She put in a good effort for her first time but it took more than that for me to cum.`);
        ImageClass.setImage(images.v4.AfterBarAnnRoom13);
        ann.talk(`I need a break, my mouth hurts.`);
        if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ || Question.globalAnswers.v3HJGuidedAnn) {

            mc.talk(`You stopped because your hand hurts earlier.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`I know... I am sorry.`);
            ann.talk(`I will get better with practice.`);
            mc.talk(`Fine.`);
            mc.talk(`Sit straight.`);
        } else {
            mc.talk(`Keep going!`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom14);
            ann.talk(`I can't I'm sorry...`);
            mc.talk(`I can cum I just need more time.`);
            ann.talk(`It's my first time, my mouth is not used to it.`);
            mc.talk(`Fine.`);
            mc.talk(`Sit straight.`);
        }

    }
    return jump(AfterClub2To4Home24LetContinueHJToAnn, "AfterClub2To4Home24LetContinueHJToAnn");
};
export const AfterClub2To4Home24LetContinueHJToAnn = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom3);

    mc.talk(`Let me touch you.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom3);
    ann.talk(`Oh...`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom23);
    mc.talk(`I like your body.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom24);
    ann.talk(`No one touched me like that before...`);
    mc.talk(`Just relax.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom22);
    ann.talk(`Ok...`);
    mc.talk(`How does it feel?`);
    ann.talk(`Good and weird at the same time.`);
    ann.talk(`Unfamiliar touch in an area I am not used to be touched...`);
    mc.talk(`Come sit on the bed.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom25);
    ann.talk(`Hey...`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom25);
    mc.talk(`Relax.`);
    ann.talk(`...`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom26);
    mc.think(`I can understand what she was saying.`);
    mc.think(`She was so nervous.`);
    mc.think(`Her body started to shiver as I rubbed my hand against her skin.`);
    ann.talk(`Oh...`);
    mc.think(`She didn't know how to react as I put my hand closer to her thighs.`);
    ImageClass.setImage(images.v4.Anim_AfterBarAnnRoomVagina.poster);
    mc.think(`Her pussy was so warm.`);
    ImageClass.setAnimation(images.v4.Anim_AfterBarAnnRoomVagina, { duration: 0 });
    ann.talk(`${mc.name}... Ah...`);
    mc.think(`My hand got closer to her clitoris.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom28);
    ann.talk(`OHH!`);
    mc.think(`Wow, that didn't take long.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom29);
    ann.talk(`Oh my God.`);
    ann.talk(`I've never felt like this before.`);
    mc.talk(`Haven't you masturbated before?`);
    ann.talk(`I have... But it's different when it's not my hand...`);
    ann.talk(`You are really good...`);
    if (mc.properties.alpha > 5) {
        mc.talk(`You just need to stop being shy and remove your clothes.`);
        ann.talk(`I am working on it, thank you for being patient with me.`);
    }

    ann.talk(`Today was a really long day.`);
    ann.talk(`I am exhausted and ready to go to sleep.`);
    mc.talk(`I am as well.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom30, { transition: true });

    ann.talk(`I am very happy to be here with you ${mc.name}.`);
    mc.talk(`So am I.`);
    ann.talk(`Good night.`);
    ImageClass.setImage(images.v4.AfterBarAnnRoom31);
    mc.talk(`Good night Ann.`);

    await endReplay(replayScenesList.v4AnnFirstBJ);
    return jump(AfterClub2To4Home24LetContinueHJToAnnEND, "AfterClub2To4Home24LetContinueHJToAnnEND");
};

